import React, { useState } from 'react';
import Caps from '../Caps/Caps';
import Cart from '../Cart/Cart';
import './Shop.css';
const Shop = () => {

    const caps = [
        {
            name: 'White Cap',
            id: 1,
            price: 50,
            img: 'https://img.freepik.com/free-psd/isolated-white-cap-mockup_125540-1040.jpg'
        },
        {
            name: 'Sky Blue Cap',
            id: 2,
            price: 60,
            img: 'https://img.freepik.com/free-psd/blue-cap-mockup_125540-1049.jpg'
        },
        {
            name: 'Black Cap',
            id: 3,
            price: 70,
            img: 'https://img.freepik.com/free-psd/black-cap-front-view-mockup_125540-1038.jpg'
        },
        {
            name: 'Military',
            id: 4,
            price: 80,
            img: 'https://img.freepik.com/free-psd/military-cap-mockup_1310-904.jpg'
        },
        {
            name: 'Pink Cap',
            id: 5,
            price: 90,
            img: ' https://img.freepik.com/free-psd/baseball-cap-mockup_1310-821.jpg'
        },
        {
            name: 'Yellow Cap',
            id: 6,
            price: 100,
            img: 'https://img.freepik.com/free-psd/cap-mockup_77323-345.jpg'
        },
        {
            name: 'Nave Cap',
            id: 7,
            price: 110,
            img: 'https://img.freepik.com/free-psd/sports-cap-logo-mockup-design-isolated_185216-377.jpg'
        },
        {
            name: 'Green Cap',
            id: 8,
            price: 120,
            img: 'https://img.freepik.com/free-psd/sports-cap-logo-mockup-design-isolated_185216-397.jpg'
        },
        {
            name: 'Chocolate Cap',
            id: 9,
            price: 130,
            img: 'https://img.freepik.com/free-psd/close-up-sports-cap-logo-mockup-isolated_185216-388.jpg'
        },
        {
            name: 'Orange Cap',
            id: 10,
            price: 140,
            img: 'https://as2.ftcdn.net/v2/jpg/03/63/26/91/1000_F_363269129_sy4ruWGVZmwQNdr31636hzxliNOAHQdz.jpg'
        },
        {
            name: 'Red Cap',
            id: 11,
            price: 150,
            img: ' https://img.freepik.com/free-psd/red-baseball-cap-mockup_1310-822.jpg'
        },
        {
            name: 'Mix Color Cap',
            id: 12,
            price: 160,
            img: 'https://img.freepik.com/free-psd/front-view-baseball-cap-mockup_1310-826.jpg'
        },
    ];

    const [cap, setCap] = useState([]);
    const handelAddToCart = (selectedCap) => {
        const newCap = [...cap, selectedCap];
        setCap(newCap);
    }
    const chooseAgainBtn = () => {
        const cap = [];
        setCap(cap);
    }
    return (
        <div className='shop-container'>
            <div className="caps-container">
                {
                    caps.map(cap => <Caps
                        cap={cap}
                        key={cap.id}
                        handelAddToCart={handelAddToCart}
                    ></Caps>)
                }
            </div>
            <div className="selected-cap">
                <Cart
                    cap={cap}
                    key={cap.id}
                    chooseAgainBtn={chooseAgainBtn}
                ></Cart>
            </div>
        </div>
    );
};

export default Shop;